import { useState } from 'react';
import api from '../api';

export const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin', dot: '#A78BFA' },
  { value: 'employee', label: 'Employee', dot: '#3b82f6' },
];

export default function useUserManagement({ onUsersChanged, showToast }) {
  const [showAddForm, setShowAddForm] = useState(false);
  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('employee');
  const [saving, setSaving] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleAddUser = async () => {
    if (!email.trim() || !displayName.trim() || !password.trim()) return;
    setSaving(true);
    try {
      await api.createUser({
        email: email.trim(),
        password: password.trim(),
        displayName: displayName.trim(),
        role,
      });
      showToast('User created successfully', 'success');
      setEmail('');
      setDisplayName('');
      setPassword('');
      setRole('employee');
      setShowAddForm(false);
      onUsersChanged();
    } catch (err) {
      showToast(err.message || 'Failed to create user', 'error');
    } finally {
      setSaving(false);
    }
  };

  const handleRoleChange = async (uid, newRole) => {
    try {
      await api.updateUser(uid, { role: newRole });
      onUsersChanged();
      showToast('Role updated', 'success');
    } catch (err) {
      showToast(err.message || 'Failed to update role', 'error');
    }
  };

  const handleDeleteUser = async () => {
    if (!deleteTarget) return;
    try {
      await api.deleteUser(deleteTarget);
      onUsersChanged();
      showToast('User removed', 'success');
    } catch (err) {
      showToast(err.message || 'Failed to delete user', 'error');
    } finally {
      setDeleteTarget(null);
    }
  };

  return {
    showAddForm, setShowAddForm,
    email, setEmail,
    displayName, setDisplayName,
    password, setPassword,
    role, setRole,
    saving,
    deleteTarget, setDeleteTarget,
    handleAddUser,
    handleRoleChange,
    handleDeleteUser,
  };
}
